import "components/Hamburger";
import { BorderTop } from "components/BorderTop";
import { initCart } from "@olmokit/core/cart";
import { CartSlide } from "components/Cart/Slide";
import { InputMenu } from "components/Search";
import { CategoryMenu } from "components/Category/Menu";
import "./index.scss";

/**
 * Component: Header
 *
 */
export function Header() {

  BorderTop();
  CartSlide();
  initCart();
  InputMenu();
  CategoryMenu();

}
